import { Link } from "react-router-dom";
import { SITELINKS } from "../../../app-routes/links";
import AdminLayout from "../common/AdminLayout";

const RoleManagement = () => {
  return (
    <AdminLayout>
      <div className="flex flex-col justify-center items-center h-[70vh] gap-3 font-semibold">
        <p>Role Management module not available</p>
        <Link to={SITELINKS.DASHBOARD_ADMIN} className="text-blue-600 text-xs underline">
          Go to dashboard
        </Link>
      </div>
    </AdminLayout>
  );
};

export default RoleManagement;
